import { Component } from '@angular/core';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps as CoreFormlyFieldProps, FormlyValidationMessage } from '@ngx-formly/core';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
}

@Component({
  selector: 'formly-wrapper-primeng-form-field',
  template: `
    <div class="grid grid-cols-12 gap-2">
      @if (props.label && props.hideLabel !== true) {
        <label [for]="id" class="flex items-center col-span-12 mb-2 md:col-span-2 md:mb-0">
          {{ props.label }}
          @if (props.required && props.hideRequiredMarker !== true) {
            <span aria-hidden="true">*</span>
          }
        </label>
      }

      <div class="col-span-12 md:col-span-10">
        <ng-container #fieldComponent></ng-container>
      </div>

      @if (showError) {
        <small class="p-error">
          <formly-validation-message class="ui-message-text" [field]="field"></formly-validation-message>
        </small>
      }
    </div>
  `,
  imports: [FormlyValidationMessage]
})
export class FormlyWrapperFormField extends FieldWrapper<FormlyFieldConfig<FormlyFieldProps>> {}
